module.exports = "p,h1{\n    color: black;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logout/logout.component.css
// module id = ./src/app/components/logout/logout.component.css
// module chunks = main